module.exports = __webpack_public_path__ + "static/ML_CircleLoop@2x-1570873dc543e0a39c221b3806985ea7.png";